var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMale = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M24.586 6H19V4h9v9h-2V7.414l-4.547 4.547A10.96 10.96 0 0 1 24 19c0 6.075-4.925 11-11 11S2 25.075 2 19 6.925 8 13 8c2.678 0 5.132.957 7.04 2.547zM13 10a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
  clipRule: "evenodd"
})));
export default SvgMale;